import React from "react";
import Slider from "react-slick";
import "../styles/CompanyOverview.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CompanyOverview = () => {
  const companyOverview = [
    {
      title: "About Us",
      description1: "Orifril Lifetech Pvt. Ltd. is a tech-driven pharmaceutical company dedicated to delivering innovative healthcare solutions. Specializing in prescription medicines and advanced nutraceuticals, we focus on promoting overall well-being. Our nutraceutical range, including vitamins, minerals, and natural supplements, utilizes AI-powered formulations to enhance immunity, digestive health, and wellness." +
        "Committed to the highest quality standards such as WHO-GMP certification, Orifril Lifetech also collaborates with international partners to advance our formulations for optimal patient care. Founded by industry experts Alankar Mishra, Vikash Sharma, and S. K. Maheshwari, we blend innovation, affordability, and safety to become a trusted leader in both pharmaceutical and nutraceutical sectors.",
      description2: "",
      icon: <img className="slider-icon" alt="about-us" src={`${process.env.PUBLIC_URL}/images/about_us.png`} />,
    },
    {
      title: "Mission",
      description1:
        "To improve lives by providing safe, innovative, and affordable pharmaceutical solutions, including nutraceuticals, vitamins, and supplements, with technically superior quality and innovative formulations. Driven by ethical practices, rigorous research, and a deep commitment to customer satisfaction and trust.",
      description2:
        "Driven by ethical practices, rigorous research, and a deep commitment to customer satisfaction and trust.",
      icon: <img className="slider-icon" alt="about-us" src={`${process.env.PUBLIC_URL}/images/mission.png`} />,
    },
    {
      title: "Vision",
      description1:
        "To be a global leader in the pharmaceutical industry, pioneering advancements in healthcare and ensuring access to affordable, groundbreaking medicines, nutraceuticals and supplements that positively impact lives.",
      description2:
        "We aim to transform health outcomes and promote healthier and more vibrant communities.",
      icon: <img className="slider-icon" alt="about-us" src={`${process.env.PUBLIC_URL}/images/vision.png`} />,
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  return (
    <section className="company-overview" id="companyOverview">
      <div className="company-overview-container">
        <h1 className="company-overview-title">Company Overview</h1>
        <Slider {...settings} className="company-overview-slider">
          {companyOverview.map((overview, index) => (
            <div className="company-overview-card" key={index}>
              <span className="company-overview-icon">{overview.icon}</span>
              <h1>{overview.title}</h1>
              <p>{overview.description1}</p>
              <p>{overview.description2}</p>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default CompanyOverview;
